let mySwiper = new Swiper('.js-slider', {
  loop: false,
  effect: 'fade',
  pagination: { el: '.swiper-pagination', clickable: !0 },
  fadeEffect: { crossFade: !0 },
  autoplay: { delay: 4e3, disableOnInteraction: !1 },
  speed: 4e3,
  allowTouchMove: !1,
});
var swiper = new Swiper('.js-slider-menu', {
  slidesPerView: 'auto',
  centeredSlides: false,
  loop: false,
  allowTouchMove: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1024: { slidesPerView: 4 },
    768: { slidesPerView: 2 },
  },
});

$(document).ready(function () {
  // Function to switch tabs
  function switchTab($tab) {
    // Remove 'is-active' class from all tab links and add it to the clicked one
    $('.tab-links a').removeClass('is-active');
    $tab.addClass('is-active');

    // Update the title text
    var title = $tab.text();
    $('.js-title').text(title);

    // Get the filter attribute of the clicked tab
    var filter = $tab.attr('data-id-en');

    // Hide all items not matching the filter and show items that match
    $('.block-menu-item')
      .not("[data-filter='" + filter + "']")
      .addClass('non-filter')
      .removeClass('block-menu-item')
      .hide();

    $("[data-filter='" + filter + "']")
      .removeClass('non-filter')
      .addClass('block-menu-item')
      .attr('style', null)
      .show();
  }

  // Click event handler for tab links
  $('.tab-links a').click(function (e) {
    e.preventDefault();
    switchTab($(this));
  });

  // Initialize the tab with data-filter="Salad" and its content on page load
  switchTab($('.tab-links a[data-id-en="Salad"]'));
});

$(document).ready(function () {});
